var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusPublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 9.52608H10.8333V4.52608C10.8333 4.30507 10.7455 4.09311 10.5893 3.93683C10.433 3.78055 10.221 3.69275 10 3.69275C9.779 3.69275 9.56703 3.78055 9.41075 3.93683C9.25447 4.09311 9.16668 4.30507 9.16668 4.52608V9.52608H4.16668C3.94566 9.52608 3.7337 9.61388 3.57742 9.77016C3.42114 9.92644 3.33334 10.1384 3.33334 10.3594C3.33334 10.5804 3.42114 10.7924 3.57742 10.9487C3.7337 11.105 3.94566 11.1927 4.16668 11.1927H9.16668V16.1927C9.16668 16.4138 9.25447 16.6257 9.41075 16.782C9.56703 16.9383 9.779 17.0261 10 17.0261C10.221 17.0261 10.433 16.9383 10.5893 16.782C10.7455 16.6257 10.8333 16.4138 10.8333 16.1927V11.1927H15.8333C16.0544 11.1927 16.2663 11.105 16.4226 10.9487C16.5789 10.7924 16.6667 10.5804 16.6667 10.3594C16.6667 10.1384 16.5789 9.92644 16.4226 9.77016C16.2663 9.61388 16.0544 9.52608 15.8333 9.52608Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusPublic);
export default __webpack_public_path__ + "static/media/plusPublic.5e9d66671bdf3ca2c3bc7b66500ead90.svg";
export { ForwardRef as ReactComponent };